import React, { BaseSyntheticEvent } from 'react'
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import CmsInformationContent from '../cmsInformationContent/CmsInformationContent'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { chevronBackOutline } from 'ionicons/icons'
import { useHistory } from 'react-router'
import { useDispatch } from 'react-redux'
import { saveCmsInformation } from '../store/cmsInformation.actions'
import { TabConstants } from '../../../components/tabs/Tabs.constants'

const CmsInformation: React.FC = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.BILLING)
  }

  const saveOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch(saveCmsInformation())
  }
  return (
    <IonPage id='CMSInformation'>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton data-testid='Save' color='primary-alt' fill='clear' onClick={saveOnClick}>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
          <IonTitle data-testid='HeaderTitle'>{t('fullChart.patient.billing.CMSInformation')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color='light'>
        <CmsInformationContent />
      </IonContent>
    </IonPage>
  )
}
export default CmsInformation
